import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BrandCreatorSetting, setBrandCreatorTaxCode } from '../../api/payment/brand-deal.api';
import { apiErrorMessage } from '../../utils/api-error-message';
import { normalizeTaxCode, validateTaxCode } from '../../utils/brand-tax';

interface Props {
  setting: BrandCreatorSetting | null;
  disabled?: boolean;
  onSaved: (s: BrandCreatorSetting) => void;
}

// Ô "Mã số thuế cá nhân (không bắt buộc)" trong phần cài đặt nhận deal (spec §3.4) — sửa được bất cứ lúc nào, để trống rồi lưu là xoá.
const CreatorTaxCodeField: React.FC<Props> = ({ setting, disabled, onSaved }) => {
  const saved = setting?.taxCode ?? '';
  const [value, setValue] = useState(saved);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setValue(saved);
  }, [saved]);

  const save = async () => {
    const invalid = validateTaxCode(value);
    if (invalid) {
      setError(invalid);
      return;
    }
    setError(null);
    const normalized = normalizeTaxCode(value);
    try {
      setBusy(true);
      const res = await setBrandCreatorTaxCode(normalized);
      onSaved(res);
      setValue(res.taxCode ?? '');
      toast.success(normalized ? 'Đã lưu mã số thuế.' : 'Đã xoá mã số thuế.');
    } catch (e) {
      setError(apiErrorMessage(e, 'Không lưu được mã số thuế, thử lại sau.'));
    } finally {
      setBusy(false);
    }
  };

  const locked = !setting || !!disabled || busy;

  return (
    <div className="ui-divider mt-3 border-t pt-3">
      <label htmlFor="creator-tax-code" className="ui-heading block text-[14px] font-bold">
        Mã số thuế cá nhân (không bắt buộc)
      </label>
      <p className="ui-muted text-[13px]">Điền mã số thuế giúp việc kê khai sau này thuận tiện hơn.</p>
      <div className="mt-2 flex flex-wrap gap-2">
        <input
          id="creator-tax-code"
          value={value}
          inputMode="numeric"
          maxLength={20}
          disabled={locked}
          onChange={(e) => {
            setValue(e.target.value);
            setError(null);
          }}
          className="ui-input w-full max-w-[260px] rounded-lg border px-3 py-2 text-[14px] disabled:opacity-60"
        />
        <button
          type="button"
          onClick={save}
          disabled={locked || normalizeTaxCode(value) === saved}
          className="rounded-lg bg-[#0057FF] px-4 py-2 text-[14px] font-semibold text-white disabled:opacity-60"
        >
          {busy ? 'Đang lưu…' : 'Lưu'}
        </button>
      </div>
      {error && (
        <p role="alert" className="mt-1 text-[13px] text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};

export default CreatorTaxCodeField;
